// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-content {
  background: transparent;
}

.tag-cloud-component {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.tag-cloud-component .tag-cloud-tag {
  display: inline-block;
}
.tag-cloud-component .tag-cloud-chip {
  padding: 3px 6px;
  cursor: default;
}
.tag-cloud-component .tag-cloud-chip:hover {
  background-color: var(--base_color2) !important;
  border-color: var(--color_neutral_800) !important;
  color: var(--color_neutral_800) !important;
}
.tag-cloud-component .tag-cloud-chip.chip-highlighted {
  background-color: var(--highlight) !important;
  border: 1px solid var(--highlight) !important;
  color: var(--base_color2) !important;
}
.tag-cloud-component .tag-cloud-chip.chip-highlighted:hover {
  background-color: var(--highlight) !important;
  border-color: var(--highlight) !important;
  color: var(--base_color2) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/TagCloud/index.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AACF;AACE;EACE,qBAAA;AACJ;AAEE;EACE,gBAAA;EACA,eAAA;AAAJ;AACI;EACE,+CAAA;EACA,iDAAA;EACA,0CAAA;AACN;AACI;EACE,6CAAA;EACA,6CAAA;EACA,oCAAA;AACN;AACM;EACE,6CAAA;EACA,yCAAA;EACA,oCAAA;AACR","sourcesContent":[".card-content {\n  background: transparent;\n}\n\n.tag-cloud-component {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n\n  .tag-cloud-tag {\n    display: inline-block;\n  }\n\n  .tag-cloud-chip {\n    padding: 3px 6px;\n    cursor: default;\n    &:hover {\n      background-color: var(--base_color2) !important;\n      border-color: var(--color_neutral_800) !important;\n      color: var(--color_neutral_800) !important;\n    }\n    &.chip-highlighted {\n      background-color: var(--highlight) !important;\n      border: 1px solid var(--highlight) !important;\n      color: var(--base_color2) !important;\n\n      &:hover {\n        background-color: var(--highlight) !important;\n        border-color: var(--highlight) !important;\n        color: var(--base_color2) !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
